export default __webpack_public_path__ + "static/media/wShoes_1.6a48b3f3.bin";